import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textoBooleano',
    standalone: false
})

export class TextoBooleanoPipe implements PipeTransform {
  transform(value: boolean): string {
    return (value) ? 'Sí' : 'No';
  }
}
